import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { Text } from '../Text';
import styles from './LearnMore.module.scss';

type Props = {
  className?: string;
};

export const LearnMore = ({ className }: Props) => {
  const pathname = usePathname();

  return (
    <Link
      className={clsx(styles.wrapper, className)}
      href={`/auth/sign-in?callbackUrl=${pathname}`}
    >
      <Text type='p3'>Дізнатись більше</Text>
    </Link>
  );
};
